import React from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Breadcrumb } from 'src/components/Breadcrumb';
import PrivateLayoutView from 'src/Layout/PrivateLayout/PrivateLayoutView';
import { AppointmentCalendar } from '../AppointmentCalendar';

const CalendarView = () => {
  return (
    <PrivateLayoutView title={<Breadcrumb items={[{ label: 'Calendar', isActive: true }]} />}>
      <AppointmentCalendar />
    </PrivateLayoutView>
  );
};

export default CalendarView;
